import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import User from '../../types/User';

interface Tokens {
    accessToken: string;
    refreshToken: string;
}

interface UserState {
    user: User | null;
    tokens: Tokens | null;
}

const accessToken = sessionStorage.getItem('accessToken');
const refreshToken = sessionStorage.getItem('refreshToken');

const initialState: UserState = {
    user: null,
    tokens: accessToken && refreshToken
        ? { accessToken, refreshToken }
        : null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserData: (
            state,
            action: PayloadAction<{ user: User; tokens: Tokens }>
        ) => {
            state.user = action.payload.user;
            state.tokens = action.payload.tokens;
            sessionStorage.setItem('accessToken', action.payload.tokens.accessToken);
            sessionStorage.setItem('refreshToken', action.payload.tokens.refreshToken);
        },
        setUserProfile: (state, action: PayloadAction<{ user: User }>) => {
            state.user = action.payload.user;
        },
        clearUserData: (state) => {
            state.user = null;
            state.tokens = null;
            sessionStorage.clear();
        },
    },
});

export const { setUserData, setUserProfile, clearUserData } = userSlice.actions;
export default userSlice.reducer;